import { FitSizes } from '../types';
export const clamp = (value: number, min: number, max: number) =>
    Math.min(max, Math.max(min, value));

export const getFitSizes = ({
    containerWidth,
    containerHeight,
    imageWidth,
    imageHeight,
    rotation,
    defaultZoom,
}: {
    containerWidth: number;
    containerHeight: number;
    imageWidth: number;
    imageHeight: number;
    rotation: number;
    defaultZoom: number;
}): FitSizes => {
    if (!containerWidth || !containerHeight || !imageWidth || !imageHeight) {
        return {
            baseWidth: 0,
            baseHeight: 0,
            boxWidth: 0,
            boxHeight: 0,
            fitScale: 0,
            fillZoom: defaultZoom,
        };
    }
    const isRotated = rotation % 180 !== 0;
    const rotatedWidth = isRotated ? imageHeight : imageWidth;
    const rotatedHeight = isRotated ? imageWidth : imageHeight;
    const fitScale = Math.min(
        containerWidth / rotatedWidth,
        containerHeight / rotatedHeight,
    );
    const baseWidth = imageWidth * fitScale;
    const baseHeight = imageHeight * fitScale;
    const boxWidth = isRotated ? baseHeight : baseWidth;
    const boxHeight = isRotated ? baseWidth : baseHeight;
    const fillZoom = Math.max(
        containerWidth / boxWidth,
        containerHeight / boxHeight,
    );
    return { baseWidth, baseHeight, boxWidth, boxHeight, fitScale, fillZoom };
};

export const getSliderValueFromZoom = ({
    zoom,
    minZoom,
    defaultZoom,
    maxZoom,
}: {
    zoom: number;
    minZoom: number;
    defaultZoom: number;
    maxZoom: number;
}) => {
    const split = 0.25;
    if (defaultZoom <= minZoom) {
        return clamp((zoom - minZoom) / (maxZoom - minZoom), 0, 1);
    }
    if (zoom <= defaultZoom) {
        return (split * (zoom - minZoom)) / (defaultZoom - minZoom);
    }
    return split + ((zoom - defaultZoom) / (maxZoom - defaultZoom)) * (1 - split);
};

export const getZoomFromSliderValue = ({
    value,
    minZoom,
    defaultZoom,
    maxZoom,
}: {
    value: number;
    minZoom: number;
    defaultZoom: number;
    maxZoom: number;
}) => {
    const split = 0.25;
    if (defaultZoom <= minZoom) {
        return minZoom + (maxZoom - minZoom) * value;
    }
    if (value <= split) {
        return minZoom + ((defaultZoom - minZoom) * value) / split;
    }
    return defaultZoom + ((maxZoom - defaultZoom) * (value - split)) / (1 - split);
};
